import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/event/blogs';
const programManagerUrl = base_url+'api/event/programManager';
const seriesTypeUrl = base_url+'api/admin/esSeriesSetup';
const subdomainTypeUrl = base_url+'api/event/esSubdomainType';

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const getprogramManager = async () => {
    const response = await api.get(programManagerUrl);
    return response.data.data;
};

export const getseriesType = async (params) => {
  const whereParam = params;
  const response = await api.post(seriesTypeUrl, whereParam);
  return response.data.data;
};

export const getsubdomainType = async (params) => {
  const whereParam = params;
  const response = await api.post(subdomainTypeUrl, whereParam);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const deleteData = async (id) => {
  const response = await api.delete(path, {
    data: { id },
  });

  return response.data;
};